import { Color, Icon, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'
import { getInfoCards } from './utils/getInfoCards'

interface CardPaymentsInfoCardsProps {
  isFreePlan: boolean
}

export const CardPaymentsInfoCards = ({ isFreePlan }: CardPaymentsInfoCardsProps): ReactElement => {
  const { t } = useTranslation()

  const infoCards = getInfoCards(isFreePlan)

  return (
    <Styled.CardsGrid>
      {infoCards.map((card) => (
        <Styled.Card key={card.titleKey}>
          <Styled.IconCircle>
            <Icon icon={card.icon} size="md" color={Color.Grey900} />
          </Styled.IconCircle>
          <Text variant="bodyLG" weight="medium">
            {t(card.titleKey)}
          </Text>
          <Text colorVariant="secondary" variant="bodySM">
            {t(card.descriptionKey)}
          </Text>
        </Styled.Card>
      ))}
    </Styled.CardsGrid>
  )
}
